import { LexicalComposer } from '@lexical/react/LexicalComposer';
// import { HistoryPlugin } from '@lexical/react/LexicalHistoryPlugin';
// import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import LexicalErrorBoundary from '@lexical/react/LexicalErrorBoundary';
import { RichTextPlugin } from '@lexical/react/LexicalRichTextPlugin';
import { MuiContentEditable } from './styles';
import {Divider } from '@mui/material';
import { lexicalEditorConfig } from '../../config/lexicalEditorConfig';
import LexicalEditorTopBar from '../LexicalEditorTopBar';
// import TreeViewPlugin from '../CustomPlugins/TreeViewPlugin';
import { ListPlugin } from '@lexical/react/LexicalListPlugin';
import { LinkPlugin } from '@lexical/react/LexicalLinkPlugin';
import ImagesPlugin from '../CustomPlugins/ImagePlugin';
import FloatingTextFormatToolbarPlugin from '../CustomPlugins/FloatingTextFormatPlugin';
// import { useCallback, useEffect, useState } from 'react';
import './style.css';
import { useIsMobile } from '../../../../hooks/misc';
import { useTranslation } from 'react-i18next';
import { keys } from '../../../../utilities/translator/translation_keys';
import Spacer from '../../../typography/Spacer';
import { Text } from '../../../typography';
import ControlledValuePlugin from '../CustomPlugins/ControlledValuePlugin';

function LexicalEditorWrapper(props) {
  const { value, onChange: onChangeCallback, onBlur, readOnly, topBarComponent } = props;
  const isMobile = useIsMobile()
  const {t} = useTranslation()
  return (
    <LexicalComposer
      initialConfig={{ ...lexicalEditorConfig, editable: !readOnly }}
    >
      <div style={{display: 'flex', justifyContent: 'space-between', flexWrap: isMobile ? 'wrap': undefined}}>
      {!readOnly && <LexicalEditorTopBar />}
     {topBarComponent || <div/>}
      </div>

      {!readOnly && <div><Spacer/><Divider /><Spacer/></div>}
      <div style={{ width: '100%' }}>
        <RichTextPlugin // #312D4B
          contentEditable={<MuiContentEditable />}
          placeholder={<div style={{marginTop: '-2.5rem', minHeight: readOnly ? undefined : '10rem'}}> <Text color="secondary" >{!readOnly ? t(keys.announcements.ENTERSOMETEXT) : ''}</Text></div>}
          ErrorBoundary={LexicalErrorBoundary}
        />
        {/* <CustomOnChangePlugin
          id={id}
          value={value}
          onChange={onChangeCallback}
        /> */}
        {/* <HistoryPlugin />
        <TreeViewPlugin /> */}
        <ListPlugin />
        <LinkPlugin />
        <ControlledValuePlugin value={value} onChange={onChangeCallback} onBlur={onBlur} />
        {/* <OnChangePlugin onChange={onChange} />*/}
        <ImagesPlugin captionsEnabled={false} /> 
        {!readOnly && <FloatingTextFormatToolbarPlugin />}
      </div>
    </LexicalComposer>
  );
}

// When the editor changes, you can get notified via the
// LexicalOnChangePlugin!
// function onChange(editorState) {
//   editorState.read(() => {
//     // Read the contents of the EditorState here.
//     // eslint-disable-next-line no-unused-vars
//     const root = $getRoot();
//     // eslint-disable-next-line no-unused-vars
//     const selection = $getSelection();
//   });
// }

// Lexical React plugins are React components, which makes them
// highly composable. Furthermore, you can lazy load plugins if
// desired, so you don't pay the cost for plugins until you
// actually use them.
// function MyCustomAutoFocusPlugin() {
//   const [editor] = useLexicalComposerContext();

//   useEffect(() => {
//     // Focus the editor when the effect fires!
//     editor.focus();
//   }, [editor]);

//   return null;
// }

export default LexicalEditorWrapper;